interface estilo
{
    backgroundColor:string,
    color:string,
    backgroundSize:string,
    borderColor:string
}

export class BotonesInicio
{
    ClassNameColor:string;
    ClassNameIcono:string;
    ClassBoton:string;
    Subtitulo:string;
    estilo:estilo;
    imagen:string;

    constructor(ClassNameColor:string,
        ClassNameIcono:string,
        ClassBoton:string,
        Subtitulo:string,
        imagen:string,
        estilo:estilo)
        {
            this.ClassNameColor=ClassNameColor
            this.ClassNameIcono=ClassNameIcono
            this.ClassBoton=ClassBoton
            this.Subtitulo=Subtitulo
            this.estilo=estilo
            this.imagen=imagen
        }
}

export const perfil:BotonesInicio=
{
    
    ClassNameColor:"bg-verde",
    ClassNameIcono:"bi bi-pencil",
    ClassBoton:"btn btn-success",
    Subtitulo:"Información Casilla",
    imagen:"url(https://apps.eshopex.cl/mi-cuenta/assets/img/fondo-perfil.png)",
    estilo:{
        backgroundColor:"#198754",
        color:"#fff",
        backgroundSize:"cover",
        borderColor:""
    }
}

export const preAlerta:BotonesInicio=
{
    
    ClassNameColor:"bg-naranjo",
    ClassNameIcono:"bi bi-plus-circle",
    ClassBoton:"btn btn-warning",
    Subtitulo:"Ingresar prealerta",
    imagen:"url(https://apps.eshopex.cl/mi-cuenta/assets/img/fondo-prealerta.png)",
    estilo:{
        backgroundColor:"#ea7218",
        color:"#fff",
        backgroundSize:"cover",
        borderColor:"#ea7218"
    }
}

export const CargasBoton:BotonesInicio=
{
    
    ClassNameColor:"bg-celeste",
    ClassNameIcono:"bi bi-search",
    ClassBoton:"btn btn-info",
    Subtitulo:"Rastreo de Carga",
    imagen:"url(https://apps.eshopex.cl/mi-cuenta/assets/img/fondo-caja.png)",
    estilo:{
        backgroundColor:"#0dcaf0",
        color:"#fff",
        backgroundSize:"cover",
        borderColor:""
    }
}

export const Pago:BotonesInicio=
{
    
    ClassNameColor:"bg-rojo",
    ClassNameIcono:"bi bi-credit-card",
    ClassBoton:"btn btn-danger",
    Subtitulo:"Pendiente de Pago",
    imagen:"url(https://apps.eshopex.cl/mi-cuenta/assets/img/fondo-peso.png)",
    estilo:{
        backgroundColor:"#dc3545",
        color:"#fff",
        backgroundSize:"cover",
        borderColor:""
    }
}